import { lazy, LazyExoticComponent, ComponentType } from "react";

const hasBeenReloadedKey = "hasBeenReloaded";

export default function lazyWithReload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
): LazyExoticComponent<T> {
  return lazy(async () => {
    const hasBeenReloaded = JSON.parse(window.sessionStorage.getItem(hasBeenReloadedKey) || "false");
    try {
      const component = await factory();

      window.sessionStorage.setItem(hasBeenReloadedKey, "false");

      return component;
    } catch (e) {
      if (!hasBeenReloaded) {
        window.sessionStorage.setItem(hasBeenReloadedKey, "true");
        window.location.reload();
      } else {
        throw e;
      }
    }
    // If this is reached, we are about to reload the page.
    // We return an empty promise so we don't get any error reports.
    return new Promise(() => {});
  });
}
